import { IStyleSettings } from "@nsdefs";

export const defaultStyles: IStyleSettings = {
  lineHeight: 1.5,
  fontSize: 14,
  tailFontSize: 16,
  fontFamily: `JetBrainsMono, "Courier New", monospace`,
};
